<template>
	<div class="full box" style="overflow: hidden;">
		<template v-if="device!='pc'">
			<div class="full flex" style="flex-direction: column;">
				<div>
					<van-tabs v-model="moduletab" @change="tabChange">
						<van-tab title="待办" name="matter"></van-tab>
						<van-tab title="消息" name="message"></van-tab>
					</van-tabs>
				</div>

				<div class="flex"
					style="padding-top: 0px;box-sizing: border-box;flex: 1;overflow: auto;position: relative;"
					v-if="moduletab=='matter'">
					<div style="width: 80px;overflow-y: auto;height: 100%;background-color: #f7f8fa;">
						<van-sidebar v-model="activeName" @change="sidebarChange">
							<van-sidebar-item :badge="data.length" title="全部" />
							<van-sidebar-item :badge="data.list.length" v-for="(data,dataindex) in tabdata"
								:key="dataindex" :title="data.title" />
						</van-sidebar>
					</div>
					<div style="position: relative;overflow: auto;height: 100%;flex: 1;">
						<div>
							<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
								<van-cell center is-link v-for="(item,index) in currenttabdata" :key="index"
									@click="open(item)">
									<template #title>
										<van-tag type="danger">{{item.tag}}</van-tag>
										<span style="margin-left: 10px;">{{item.title}}</span>
										<div>
											<van-tag v-for="(kitem,kindex) in item.keyword" plain :key="kindex" type="primary" style="margin-right: 10px;">
												{{kindex + '：' + kitem}}
											</van-tag>
										</div>										
									</template>
									<template #right-icon>
										<div style="margin-left: 10px;">
											<van-tag type="primary" v-if="item.type==1">提交</van-tag>
											<van-tag type="danger" v-if="item.type==2">退回</van-tag>
											<van-tag type="info" v-if="item.type==3">取回</van-tag>
											<van-tag type="success" v-if="item.type==-1">保存待发</van-tag>
										</div>
									</template>
								</van-cell>
							</van-list>
						</div>
					</div>
				</div>

				<div class="flex" style="padding-top: 0px;box-sizing: border-box;flex: 1;position: relative;"
					v-if="moduletab=='message'">
					<div class="full">
						<messageIndex />
					</div>
				</div>

			</div>
		</template>
		<template v-else>
			<el-form size="mini" :inline="true" class="matterform" v-if="istab">
				<el-form-item label="查询">
					<el-input @input="keywordChange" v-model="keyword" placeholder="关键词" :clearable="true"></el-input>
				</el-form-item>
				<!-- 				<el-form-item>
					<el-button type="" @click="reset">重置</el-button>
				</el-form-item> -->
			</el-form>
			<el-tabs v-model="activeName" v-if="istab">
				<template v-for="(data,dataindex) in tabdata">
					<el-tab-pane :name="data.title" :key="dataindex">
						<span slot="label">
							<div>
								<span>{{data.title}}</span>
								<span class="el-badge__content" style="margin-left: 4px;"
									v-if="data.list.length!=0">{{data.list.length}}</span>
							</div>
						</span>
						<div>
							<el-checkbox v-model="data.active" style="margin-right: 10px;"
								@change="totalcheckboxChange(data)"></el-checkbox>
							<el-button type="text" size="mini" @click="submitbatch">批量提交</el-button>
							<div style="width: 100%;height: 1px;background: rgb(233, 233, 235);margin: 2px;"></div>
							<el-row class="item_container" style="overflow: auto;height: 180px;">
								<el-col style="margin-bottom: 10px;width: 100%;" :span="24"
									v-for="(item,index) in data.list" :key="index">
									<div class="item flex">
										<el-checkbox v-model="item.active" style="margin-right: 10px;"></el-checkbox>
										<div style="flex: 1;width: 100px;">
											<div style="width: 100%;">
												<el-link class="flowprogress" :style="{fontSize:fontSize+'px'}"
													:underline="true" @click="open(item)">
													<el-tag type="danger" size="mini"
														v-if="item.tag">{{item.tag}}</el-tag>
													{{item.title}}
												</el-link>
												<template v-if="item.keyword || item.flowmark">
													<el-tag effect="dark" size="mini" type="info"
														style="margin-right: 10px;"
														v-if="item.flowmark">{{item.flowmark}}</el-tag>
													<template v-for="(item,index) in item.keyword">
														<el-tag effect="plain" size="mini" type="" :key="index"
															style="margin-right: 10px;"
															v-if="item">{{index+'：'+ item}}</el-tag>
													</template>
												</template>
											</div>
										</div>
										<div v-if="showTag" style="margin-left: 20px;">
											<el-tag size="mini" v-if="item.type==1">提交</el-tag>
											<el-tag size="mini" type="danger" v-if="item.type==2">退回</el-tag>
											<el-tag size="mini" type="info" v-if="item.type==3">取回</el-tag>
											<el-tag size="mini" type="success" v-if="item.type==-1">保存待发</el-tag>
										</div>
									</div>
								</el-col>
							</el-row>
						</div>
					</el-tab-pane>
				</template>
			</el-tabs>
			<el-row v-else class="item_container">
				<el-col style="margin-bottom: 10px;width: 100%;" :span="24" v-for="(item,index) in data" :key="index">
					<div class="item flex">
						<div style="flex: 1;width: 100px;">
							<div style="width: 100%;">
								<el-link class="flowprogress" :style="{fontSize:fontSize+'px'}" :underline="true"
									@click="open(item)">
									<el-tag type="danger" size="mini" v-if="item.tag">{{item.tag}}</el-tag>
									{{item.title}}
								</el-link>
								<template v-if="item.keyword">
									<el-tag size="mini" effect="plain" type="" v-for="(item,index) in item.keyword"
										:key="index" style="margin-right: 10px;">{{index+'：'+item}}</el-tag>
								</template>
							</div>
						</div>
						<div v-if="showTag" style="margin-left: 20px;">
							<el-tag size="mini" v-if="item.type==1">提交</el-tag>
							<el-tag size="mini" type="danger" v-if="item.type==2">退回</el-tag>
							<!-- <el-tag size="mini" type="info" v-if="item.type==3">知会</el-tag> -->
							<el-tag size="mini" type="success" v-if="item.type==-1">保存待发</el-tag>
						</div>
					</div>
				</el-col>
			</el-row>
		</template>
	</div>
</template>
<style scoped>
	.box {
		box-sizing: border-box;
		padding: 4px 10px;
	}

	.item {
		position: relative;
		width: 100%;
		flex-direction: row;

	}

	.flowprogress {
		position: relative;
		width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		display: block;

	}

	.item_container {
		width: 100%;
		height: 220px;
		overflow: auto;
		box-sizing: border-box;
		padding: 10px 10px 10px 0;
	}

	.matterform .el-form-item {
		margin-bottom: 0px;
	}
</style>
<script>
	import messageIndex from '@_system/views/main/cooperate/message/index.vue'
	export default {
		name: 'flowprogress',
		props: {
			showTag: {
				type: Boolean,
				default: () => {
					return true
				}
			},
			fontSize: {
				type: Number,
				default: () => {
					return 14
				}
			},
			istab: {
				type: Boolean,
				default: () => {
					return true
				}
			},
		},
		data() {
			return {
				moduletab: 'matter',
				keyword: '',
				activeName: null,
				loading: true,
				finished: false,
				moduleName: 'flowprogress',
				data: [],
				tabdata: [],
				currenttabdata: [],
				keyworddata: [],
				device: window.systemMethods.device()
			}
		},
		watch: {
			socketTimestamp() {
				let message = this.$store.state.system.websocketMessage
				if (message.event == 'FLOW') {
					setTimeout(() => {
						this.list()
					}, 1000)
				}
				if (message.event == 'NOTICE') {
					setTimeout(() => {
						this.list()
					}, 1000)
				}
			}
		},
		created() {

		},
		mounted() {
			this.list()
		},
		computed: {
			socketTimestamp() {
				return this.$store.state.system.socketTimestamp
			}
		},

		methods: {
			list() {
				let tabdata = []
				this.tabdata = []
				return new Promise((resove) => {
					this.loading = true
					this.$api[this.moduleName].list().then((res) => {
						res.list.forEach((item, index) => {
							item.active = false
							if (item.flowKeywordsFormmater && item.keyword) {
								for (let i in item.flowKeywordsFormmater) {
									if (item.keyword[i]) {
										if (item.flowKeywordsFormmater[i].type == '$emun') {
											item.keyword[i] = window.systemMethods.getEmunValue(
												item.flowKeywordsFormmater[i].name, item
												.keyword[i])
										}
										if (item.flowKeywordsFormmater[i].type == 'time') {
											item.keyword[i] = window.systemMethods.timestampToDate(
												item
												.keyword[i], true)
										}
									}
								}
							}
							let titlearr = item.title.split('--')
							let obj = tabdata.find((td) => {
								return td.title == titlearr[1]
							})
							if (!obj) {
								tabdata.push({
									title: titlearr[1],
									list: [item],
									active: false
								})
							} else {
								obj.list.push(item)
							}
							if (index == 0) {
								this.activeName = this.device == 'pc' ? titlearr[1] : 0
							}
						})
						if (this.device == 'pc') {
							tabdata.push({
								title: '筛选',
								list: [],
								active: false
							})
						}

						this.tabdata = tabdata
						//console.log(this.tabdata)
						this.data = res.list
						this.currenttabdata = res.list
						if (this.keyword) {
							this.keywordChange(this.keyword)
						}
						resove()
						this.loading = false
						this.finished = true
					})
				})
			},
			totalcheckboxChange(data) {
				data.list.forEach((item) => {
					item.active = data.active
				})
			},
			submitbatch() {
				let checkboxdata = []
				let currentlist = []
				this.tabdata.forEach((item) => {
					if (item.title == this.activeName) {
						currentlist = item.list
					}
				})
				currentlist.forEach((item) => {
					if (item.active) {
						checkboxdata.push(item)
					}
				})
				if (checkboxdata.length != 0) {
					this.$confirm('是否批量提交', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						if(checkboxdata.length>50){
							this.$message.error('不能超过50条数据')
							return
						}
						// let checkboxdatagroup = this.$Lodash.groupBy(checkboxdata, 'route')
						
						// console.log(checkboxdatagroup)
						// for(let i in checkboxdatagroup){
						// 	checkboxdatagroup[i] = this.$Lodash.map(checkboxdatagroup[i], item=>this.$Lodash.pick(item, ['id','dataid']))
							
						// }
						
						let handle = this.$loading()						
						checkboxdata.forEach((item) => {							
							fetch(window.config.baseURL + '/' + window.config.app +
								'/flowprogress/onlysubmit/'+item.route, {
									method: "post",
									headers: {
										'Content-Type': 'application/json',
										'token': window.localStorage.getItem(this.$store.state.token)
									},
									body: JSON.stringify({
										dataid: item.dataid,
										flowprogressid: item.id
									})
								}).then((response) => {
									if(!response.ok){
										this.$loadingclose(handle)
										throw new Error('请求错误')
									}
									return response.json()
									
								}).then((res) => {
									if(res.code!=200){										
										this.$message.error(res.msg)
									}
									this.$loadingclose(handle)								
								},(e)=>{
									this.$loadingclose(handle)
									this.$message.error(e.msg)
								}).catch((e)=>{
									this.$loadingclose(handle)
									this.$message.error(e.msg)
								})
						})
						// console.log(checkboxdata)
					}).catch(() => {

					})

				} else {
					this.$message.error('请选择数据')
				}

			},
			onLoad() {

			},
			open(data) {
				let res = this.$router.resolve({
					name: 'update',
					query: {
						name: data.formname.slice(2),
						id: data.dataid,
						controlltype: 2,
						windowName: data.title,
						extra: JSON.stringify({
							componentname: data.flowcomponentname
						}),
						isflow: 1,
						flowprogressid: data.id
					}
				})
				if (this.device != 'pc') {
					this.$router.push(res.href.replace(/#/g, ''))
				} else {
					let win = window.open(res.href, this.moduleName + "update",
						this.$store.state.system.windowConfig)
					win.onload = () => {
						console.log(this.moduleName + 'form open')
					}
				}
			},
			keywordChange(e) {
				let data = []
				if (e) {
					data = this.data.filter((item) => {
						let keyword = []
						for (let i in item.keyword) {
							if (item.keyword[i]) {
								keyword.push(item.keyword[i])
							}

						}
						
						let targetKey = keyword.findIndex((kw) => {
							return kw.toString().indexOf(e) !== -1
						})
						return item.title.indexOf(e) !== -1 || targetKey !== -1
					})
					this.keyworddata = data
					if (this.keyworddata.length != 0) {
						this.activeName = '筛选'
					}
					let obj = this.tabdata.find((td) => {
						return td.title == '筛选'
					})
					if (obj) {
						obj.list = data
					}

				} else {
					this.list()
				}
			},
			sidebarChange(e) {
				if (e == 0) {
					this.currenttabdata = this.data
				} else {
					this.currenttabdata = this.tabdata[e - 1].list
				}
			},
			tabChange() {
				console.log(this.moduletab)
			}
		},
		components: {
			messageIndex
		}
	}
</script>